module.exports = __webpack_public_path__ + "media/images/rocket-727bf6727430366f3842035c4af5bbb1.svg";